module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "single",
    attrs: {
      "id": _vm.id
    }
  }, [_c('div', {
    staticClass: "singleTitle",
    on: {
      "click": function($event) {
        _vm.expandSingle(_vm.id)
      }
    }
  }, [(!_vm.showSingle) ? [_c('h1', {
    staticClass: "singleRealName",
    style: ({}),
    domProps: {
      "innerHTML": _vm._s(_vm.workstudent)
    }
  }), _vm._v(" "), _c('h1', {
    staticClass: "singleRealTitle",
    class: _vm.addTitleLengthClass,
    style: ({
      width: 'calc(100% - ' + _vm.nameWidth + 'px)'
    }),
    attrs: {
      "id": 'title' + _vm.id
    },
    domProps: {
      "innerHTML": _vm._s(_vm.title)
    }
  })] : [_c('h1', {
    staticClass: "singleRealName singleExpanded",
    style: ({
      'border-top': '1px solid ' + _vm.yearColor,
      color: _vm.yearColor
    }),
    domProps: {
      "innerHTML": _vm._s(_vm.workstudent)
    }
  }), _vm._v(" "), _c('h1', {
    staticClass: "singleRealTitle singleExpanded",
    class: _vm.addTitleLengthClass,
    style: ({
      'border-top': '1px solid ' + _vm.yearColor,
      color: _vm.yearColor,
      'border-left': '1px solid ' + _vm.yearColor,
      width: 'calc(100% - ' + (_vm.nameWidth + _vm.closeWidth) + 'px)'
    }),
    attrs: {
      "id": 'title' + _vm.id
    },
    domProps: {
      "innerHTML": _vm._s(_vm.title)
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "close"
  })]], 2), _vm._v(" "), _c('div', {
    staticClass: "singleContent",
    class: {
      expanded: _vm.showSingle
    }
  }, [(_vm.postJsonContentFeaturedImage) ? _c('div', {
    staticClass: "singleContentInnerLeftLink",
    style: ({
      'height': _vm.linkLineHeight + 'px'
    }),
    attrs: {
      "cameFromIndex": true
    }
  }, [_c('router-link', {
    attrs: {
      "to": {
        path: 'work/' + _vm.id,
        query: {
          yearview: _vm.index
        }
      }
    }
  }, [_c('span', [_vm._v("Read More")])])], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "singleContentInner"
  }, [_c('div', {
    staticClass: "singleContentInnerFeatured"
  }, [(_vm.postJsonContentFeaturedImage) ? _c('img', {
    directives: [{
      name: "lazy",
      rawName: "v-lazy",
      value: (_vm.postJsonContentFeaturedImage),
      expression: "postJsonContentFeaturedImage"
    }],
    style: ({
      'height': _vm.featuredImageCalculatedHeight
    })
  }) : _vm._e(), _vm._v(" "), (_vm.postJsonContentFeaturedImage) ? _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.postJsonContentFeaturedImageLoaded),
      expression: "!postJsonContentFeaturedImageLoaded"
    }],
    staticClass: "loadingText"
  }, [_c('span', [_vm._v("\n            LOADING\n          ")])]) : _vm._e()]), _vm._v(" "), (!_vm.postJsonContentFeaturedImage) ? _c('router-link', {
    staticClass: "singleContentInnerLink",
    style: ({
      'border-top-color': _vm.yearColor
    }),
    attrs: {
      "to": {
        path: 'work/' + _vm.id,
        query: {
          yearview: _vm.index
        }
      }
    }
  }, [_c('span', [_vm._v("Read More")])]) : _vm._e(), _vm._v(" "), (_vm.postJsonContentFeaturedImage) ? [_c('div', {
    staticClass: "singleContentInnerRenderedWrapper",
    style: ({
      'margin-bottom': _vm.linkLineHeight + 'px'
    })
  }, [_c('p', {
    staticClass: "singleContentInnerRenderedFullTitle"
  }, [_c('span', {
    domProps: {
      "innerHTML": _vm._s(_vm.workstudent)
    }
  }), _vm._v(" "), _c('br'), _vm._v(" "), _c('span', {
    domProps: {
      "innerHTML": _vm._s(_vm.fulltitle)
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "singleContentInnerRendered",
    style: ({
      background: _vm.yearColor
    }),
    domProps: {
      "innerHTML": _vm._s(_vm.postJsonContent)
    }
  })])] : [_c('div', {
    staticClass: "singleContentInnerRenderedWrapper"
  }, [_c('p', {
    staticClass: "singleContentInnerRenderedFullTitle"
  }, [_c('span', {
    domProps: {
      "innerHTML": _vm._s(_vm.workstudent)
    }
  }), _vm._v(" "), _c('br'), _vm._v(" "), _c('span', {
    domProps: {
      "innerHTML": _vm._s(_vm.fulltitle)
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "singleContentInnerRendered",
    domProps: {
      "innerHTML": _vm._s(_vm.postJsonContent)
    }
  })])]], 2)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-2f0b16a4!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Singlepostindex.vue
// module id = 57
// module chunks = 1